import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()


export const getBlog = (abortToken) => {
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.get("/Blogs", config);
  }

  export const createBlog =(data ,abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };    return api.post(`/Blogs`, data, config)
}

export const updateBlog =(id, data,abortToken )=>{
  const config = {
      ...abortToken,
      timeout: 30000, // Set the timeout for this specific request
    };    return api.put(`/Blogs/${id}`, data, config)
}

export const deleteBlog =(id,abortToken)=>{
  const config = {
      ...abortToken,
      timeout: 30000, // Set the timeout for this specific request
    };    return api.delete(`/Blogs/${id}`, config)
}